import React from "react";
import { Box } from "@mantine/core";
import BottomSheet from "../../../common/BottomSheet";
import SheetOption from "./SheetOption";
import styles from "./MobileSheets.module.css";

export interface SheetAction {
  key: string;
  label: string;
  icon: React.ReactNode;
  onClick: () => void;
  disabled?: boolean;
  danger?: boolean;
}

export interface MobileActionsSheetProps {
  opened: boolean;
  onClose: () => void;
  /** The report's name. */
  title: string;
  actions: SheetAction[];
}

/** The report's "…" menu on a phone. Picking an action closes the sheet. */
export default function MobileActionsSheet({
  opened,
  onClose,
  title,
  actions,
}: MobileActionsSheetProps) {
  return (
    <BottomSheet
      labelDialog
      opened={opened}
      onClose={onClose}
      title={title}
      data-testid="report-actions-sheet"
    >
      <Box className={styles.options}>
        {actions.map((action) => (
          <SheetOption
            key={action.key}
            label={action.label}
            icon={action.icon}
            danger={action.danger}
            disabled={action.disabled}
            onClick={() => {
              onClose();
              action.onClick();
            }}
          />
        ))}
      </Box>
    </BottomSheet>
  );
}
